import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '@wa/shared';

const navigation = [
  { to: '/overview', label: 'Overview' },
  { to: '/tenants', label: 'Tenants' },
  { to: '/onboarding', label: 'Onboarding' },
  { to: '/channels', label: 'Channels' },
  { to: '/templates', label: 'Templates' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/reports', label: 'Reports' },
  { to: '/bots', label: 'Bots' },
  { to: '/errors', label: 'Errors' },
  { to: '/jobs', label: 'Jobs' },
  { to: '/audit', label: 'Audit' },
  { to: '/staff', label: 'Staff' },
];

export function AdminShell() {
  const { user, signOut } = useAuth();

  return (
    <div className="flex h-full flex-col">
      <header className="flex flex-wrap items-center gap-x-6 gap-y-2 border-b border-(--color-line) bg-(--color-surface) px-5 py-3">
        <span className="text-body font-semibold tracking-tight">Platform admin</span>
        <nav className="flex flex-wrap gap-1">
          {navigation.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  'rounded px-3 py-1.5 text-body transition-colors',
                  isActive
                    ? 'bg-(--color-brand-soft) text-(--color-brand) font-medium'
                    : 'text-(--color-muted) hover:text-(--color-ink)',
                ].join(' ')
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-3 text-small text-(--color-muted)">
          <span>{user?.displayName}</span>
          <button
            type="button"
            onClick={() => void signOut()}
            className="rounded border border-(--color-line) px-2 py-1 hover:text-(--color-ink)"
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="min-h-0 flex-1 overflow-y-auto"><Outlet /></main>
    </div>
  );
}
